(() => {
  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const stage = root.querySelector('[data-zoom]');
    const photo = stage.querySelector('img');
    const dialog = root.querySelector('dialog');
    const enlarged = dialog.querySelector('img');
    root.querySelectorAll('[data-photo]').forEach(button => button.addEventListener('click', () => {
      photo.removeAttribute('srcset');
      photo.src = button.dataset.photo;
      photo.alt = button.dataset.alt;
      stage.href = button.dataset.photo;
      enlarged.src = button.dataset.photo;
      enlarged.alt = button.dataset.alt;
      root.querySelector('[data-caption-output]').textContent = button.dataset.caption;
      root.querySelectorAll('[data-photo]').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
    }));
    stage.addEventListener('click', event => {
      if (!dialog.showModal) return;
      event.preventDefault();
      dialog.showModal();
    });
    dialog.querySelector('[data-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('close', () => stage.focus());
    const quantity = root.querySelector('[name="quantity"]');
    root.querySelectorAll('[data-step]').forEach(button => button.addEventListener('click', () => {
      if (button.dataset.step === '1') quantity.stepUp(); else quantity.stepDown();
      quantity.dispatchEvent(new Event('change', {bubbles: true}));
    }));
    root.querySelectorAll('[data-unit]').forEach(button => button.addEventListener('click', () => {
      root.querySelectorAll('[data-in]').forEach(cell => { cell.textContent = cell.dataset[button.dataset.unit] + ' ' + button.dataset.unit; });
      root.querySelectorAll('[data-unit]').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
    }));
  }
  document.querySelectorAll('.sereni').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('.sereni').forEach(init));
})();
